import * as THREE from 'three';

/**
 * WebGL renderer bound to a canvas, sized to the window and kept in sync
 * with it. Returns the renderer plus a dispose() that removes the listener.
 */
export function createRenderer(canvas, camera) {
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  function resize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  resize();
  window.addEventListener('resize', resize);

  return {
    renderer,
    dispose() {
      window.removeEventListener('resize', resize);
      renderer.dispose();
    },
  };
}
